/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSquareIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-square"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.85 21.8Q3.73 21.8 2.96 21.04Q2.2 20.27 2.2 19.15L2.2 4.85Q2.2 3.73 2.96 2.96Q3.73 2.2 4.85 2.2L19.15 2.2Q20.27 2.2 21.04 2.96Q21.8 3.73 21.8 4.85L21.8 19.15Q21.8 20.27 21.04 21.04Q20.27 21.8 19.15 21.8Z" fill={color} />
    </svg>
  );
}
